<template>
  <g>
    <path
      d="M6.22068 12.4399C5.14553 12.4399 4.26587 13.3196 4.26587 14.3948V22.7116C4.26587 22.9781 4.48801 23.2003 4.75457 23.2003H8.17549V14.3948C8.17549 13.3196 7.30471 12.4399 6.22068 12.4399Z"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M25.7768 12.4399C24.6928 12.4399 23.822 13.3196 23.822 14.3948V23.2003H27.2429C27.5095 23.2003 27.7316 22.9781 27.7316 22.7116V14.3948C27.7405 13.3196 26.8609 12.4399 25.7768 12.4399Z"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M8.17627 23.2024H23.8236"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M8.21167 17.8274H23.8235"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M6.21997 12.4411V10.4863C6.21997 9.41116 7.09963 8.53149 8.17478 8.53149H23.8221C24.9062 8.53149 25.7769 9.41116 25.7769 10.4863V12.4411"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M6.21997 23.2024V24.6685"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
    <path
      d="M25.7783 23.2024V24.6685"
      :stroke="iconColor"
      stroke-width="1.77974"
      stroke-miterlimit="10"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
